import { APICore } from '../../helpers/api/apiCore';
import * as URL from '../../helpers/api/apiEndPoint';

const api = new APICore();

function Dashboard(params: any): any {
    // const { search } = params.data;
    return api.get(`${URL.DASHBOARD_GET}`);
}

export { Dashboard };
